export default "__VITE_ASSET__ClfsS0Pt__"